import {
  BooleanInput,
  Create,
  ListButton,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";
import { ReferenceSelectInput } from "@/inputs/ReferenceSelectInput";

import { ipV4Vallidator } from "../utils/ipV4Vallidator";

import { RadiusVpnServerPrivacyTypeInput } from "./RadiusVpnServerPrivacyTypeInput";
import { RadiusVpnServerProtocolCsvInput } from "./RadiusVpnServerProtocolCsvInput";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const RadiusVpnServersCreate = () => {
  return (
    <Create actions={<CreateActions />} redirect="list">
      <SimpleForm toolbar={<CreateToolbar />}>
        <TextInput
          source="ip"
          helperText="Example: 127.0.0.1"
          validate={[required(), ipV4Vallidator]}
        />
        <TextInput
          source="host"
          helperText="Example: https://hostname.com"
          defaultValue="https://"
          validate={[required()]}
        />
        <BooleanInput source="active" defaultChecked={false} />
        <RadiusVpnServerPrivacyTypeInput source="privacyType" />
        <ReferenceSelectInput
          module={MODULE_NAMES.ACCESS_LEVELS}
          source="accessLevel"
          optionText="title"
          optionValue="@id"
          validate={[required()]}
        />
        <ReferenceSelectInput
          module={MODULE_NAMES.DATA_CENTERS}
          source="dataCenter"
          optionText="name"
          optionValue="@id"
          validate={[required()]}
        />
        <ReferenceSelectInput
          module={MODULE_NAMES.CITIES}
          source="city"
          optionText="name"
          optionValue="@id"
          validate={[required()]}
        />
        <ReferenceSelectInput
          module={MODULE_NAMES.COUNTRIES}
          source="country"
          optionText="name"
          optionValue="@id"
          validate={[required()]}
        />
        <RadiusVpnServerProtocolCsvInput
          source="protocolsCsv"
          validate={[required()]}
        />
        <BooleanInput source="autoCreated" defaultChecked={false} />
      </SimpleForm>
    </Create>
  );
};
